(function () {
  'use strict';

  var COUPON_API_BASE = 'https://api.tripcnguide.com/api/v1/coupons';
  var USED_PAGE_SIZE = 10;
  var ACTIVE_TAB_KEY = 'tcng_coupons_active_tab';

  var root = document.querySelector('[data-my-coupons]');
  if (!root) return;

  // Check login state and initialize auth
  var auth = window.TripCNAuth;
  var currentUserEmail = '';
  var token = '';

  function initializePage() {
    token = auth && typeof auth.getAccessToken === 'function' ? auth.getAccessToken() : '';

    if (!token) {
      // Not logged in, redirect to login
      var returnUrl = encodeURIComponent(window.location.href);
      window.location.href = '/account/login?return_url=' + returnUrl;
      return;
    }

    // Try to get email from auth
    if (auth && typeof auth.getState === 'function') {
      try {
        var authState = auth.getState();
        currentUserEmail = (authState && authState.user && authState.user.email) || '';
      } catch (error) {
        currentUserEmail = '';
      }
    }

    // If email not available from auth, try from stored user data
    if (!currentUserEmail) {
      try {
        var storedUser = window.localStorage.getItem('tcng_user');
        if (storedUser) {
          var parsed = JSON.parse(storedUser);
          currentUserEmail = (parsed && parsed.email) || '';
        }
      } catch (error) {
        currentUserEmail = '';
      }
    }

    // If still no email, wait for auth to initialize
    if (!currentUserEmail && auth && typeof auth.initialize === 'function') {
      auth.initialize().then(function() {
        var authState = auth.getState();
        if (authState && authState.user && authState.user.email) {
          currentUserEmail = authState.user.email;
          startApp();
        } else {
          showError('available', 'Email address not found. Please log in again.');
          showError('used', 'Email address not found. Please log in again.');
          showError('expired', 'Email address not found. Please log in again.');
        }
      }).catch(function() {
        showError('available', 'Email address not found. Please log in again.');
        showError('used', 'Email address not found. Please log in again.');
        showError('expired', 'Email address not found. Please log in again.');
      });
      return;
    }

    startApp();
  }

  // Tab elements
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-coupon-tab]'));
  var panels = {
    available: root.querySelector('[data-coupon-panel="available"]'),
    used: root.querySelector('[data-coupon-panel="used"]'),
    expired: root.querySelector('[data-coupon-panel="expired"]')
  };

  var listElements = {
    available: root.querySelector('[data-coupon-list-available]'),
    used: root.querySelector('[data-coupon-list-used]'),
    expired: root.querySelector('[data-coupon-list-expired]')
  };

  var emptyElements = {
    available: root.querySelector('[data-coupon-empty-available]'),
    used: root.querySelector('[data-coupon-empty-used]'),
    expired: root.querySelector('[data-coupon-empty-expired]')
  };

  var errorElements = {
    available: root.querySelector('[data-coupon-error-available]'),
    used: root.querySelector('[data-coupon-error-used]'),
    expired: root.querySelector('[data-coupon-error-expired]')
  };

  var errorTextElements = {
    available: root.querySelector('[data-coupon-error-text-available]'),
    used: root.querySelector('[data-coupon-error-text-used]'),
    expired: root.querySelector('[data-coupon-error-text-expired]')
  };

  var usedState = {
    page: 1,
    total: 0,
    pages: 1
  };

  var paginationEl = root.querySelector('[data-coupon-pagination-used]');
  var paginationPrev = root.querySelector('[data-pagination-prev]');
  var paginationNext = root.querySelector('[data-pagination-next]');
  var paginationInfo = root.querySelector('[data-pagination-info]');

  // Utility functions
  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function apiHeaders() {
    var headers = { Accept: 'application/json' };
    if (token) headers.Authorization = 'Bearer ' + token;
    return headers;
  }

  function apiError(message, status) {
    var error = new Error(message || 'The coupon service returned an error.');
    error.status = Number(status) || 0;
    return error;
  }

  function apiRequest(url) {
    return fetch(url, { headers: apiHeaders() }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (json) {
        if (!response.ok || !json) throw apiError('Service temporarily unavailable. Please try again later.', response.status);
        var code = String(json.code || '');
        if (code !== '200' && code !== '0' && code.toUpperCase() !== 'SUCCESS') {
          throw apiError(json.msg || json.message || 'Failed to load coupons.', response.status);
        }
        return json.data !== undefined ? json.data : json;
      });
    });
  }

  function formatDiscount(coupon) {
    if (!coupon) return '';
    var type = String(coupon.type || coupon.couponType || '').toUpperCase();
    switch (type) {
      case 'DISCOUNT':
        return Number(coupon.discountPercent) + '% off';
      case 'CASH':
        return '$' + Number(coupon.cashAmount).toFixed(2) + ' off';
      case 'THRESHOLD':
        return 'Spend $' + Number(coupon.thresholdAmount) + ', get $' + Number(coupon.thresholdDiscount) + ' off';
      default:
        return '';
    }
  }

  function formatExpiry(coupon) {
    var until = coupon.validUntil || coupon.validUntilDate || '';
    if (!until) return '';
    var date = new Date(until);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function formatCurrency(value) {
    var amount = Number(value || 0);
    return '$' + amount.toFixed(2);
  }

  function applicableBusinesses(coupon) {
    var businesses = coupon.applicableBusinesses || coupon.businessType || '';
    if (Array.isArray(businesses)) {
      var map = { TRAIN: 'Train', ESIM: 'eSIM', TRAVEL: 'Travel' };
      return businesses.map(function (b) { return map[b] || b; }).join(', ');
    }
    var text = String(businesses || '');
    return text
      .replace(/TRAIN/g, 'Train')
      .replace(/ESIM/g, 'eSIM')
      .replace(/TRAVEL/g, 'Travel');
  }

  function goToBusinessPage(coupon) {
    var businesses = coupon.applicableBusinesses || coupon.businessType || 'TRAIN';
    var text = Array.isArray(businesses) ? businesses.join(',') : String(businesses);
    if (text.indexOf('TRAIN') !== -1) {
      window.location.href = '/pages/train-booking';
    } else if (text.indexOf('ESIM') !== -1) {
      window.location.href = '/pages/esim';
    } else {
      window.location.href = '/pages/train-booking';
    }
  }

  // Render functions
  function renderCouponCard(coupon, status) {
    var name = escapeHTML(coupon.couponName || coupon.name || coupon.couponCode || 'Coupon');
    var desc = escapeHTML(formatDiscount(coupon));
    var expiry = formatExpiry(coupon);
    var businesses = applicableBusinesses(coupon);

    var card = document.createElement('div');
    card.className = 'my-coupons__card my-coupons__card--' + status;

    var body = document.createElement('div');
    body.className = 'my-coupons__card-body';

    var title = document.createElement('strong');
    title.className = 'my-coupons__card-title';
    title.textContent = name;

    var descEl = document.createElement('span');
    descEl.className = 'my-coupons__card-desc';
    descEl.textContent = desc;

    var meta = document.createElement('span');
    meta.className = 'my-coupons__card-meta';
    var metaText = [];
    if (businesses) metaText.push('Applicable: ' + businesses);
    if (expiry) metaText.push('Valid until ' + expiry);
    meta.textContent = metaText.join(' · ');

    body.appendChild(title);
    body.appendChild(descEl);
    body.appendChild(meta);

    card.appendChild(body);

    if (status === 'available') {
      var useButton = document.createElement('button');
      useButton.type = 'button';
      useButton.className = 'my-coupons__use-btn';
      useButton.textContent = 'Use now';
      useButton.addEventListener('click', function () {
        goToBusinessPage(coupon);
      });
      card.appendChild(useButton);
    } else if (status === 'used') {
      var usedInfo = document.createElement('div');
      usedInfo.className = 'my-coupons__card-used';
      var usedOrder = document.createElement('span');
      usedOrder.textContent = 'Used on order: ' + escapeHTML(coupon.usedOrderNo || '—');
      var usedTime = document.createElement('span');
      usedTime.textContent = 'Used at: ' + formatDate(coupon.usedAt || coupon.usedTime || '');
      var usedDiscount = document.createElement('span');
      usedDiscount.textContent = 'Discounted: ' + formatCurrency(coupon.discountAmount || coupon.usedDiscountAmount || 0);
      usedInfo.appendChild(usedOrder);
      usedInfo.appendChild(usedTime);
      usedInfo.appendChild(usedDiscount);
      card.appendChild(usedInfo);
    } else {
      var expiredBadge = document.createElement('span');
      expiredBadge.className = 'my-coupons__badge my-coupons__badge--expired';
      expiredBadge.textContent = 'Expired';
      card.appendChild(expiredBadge);
    }

    return card;
  }

  function showLoading(tab) {
    var panel = panels[tab];
    var loading = panel.querySelector('[data-coupon-loading]');
    if (loading) loading.hidden = false;
    if (listElements[tab]) listElements[tab].innerHTML = '';
    if (emptyElements[tab]) emptyElements[tab].hidden = true;
    if (errorElements[tab]) errorElements[tab].hidden = true;
  }

  function hideLoading(tab) {
    var panel = panels[tab];
    var loading = panel.querySelector('[data-coupon-loading]');
    if (loading) loading.hidden = true;
  }

  function showError(tab, message) {
    hideLoading(tab);
    if (listElements[tab]) listElements[tab].innerHTML = '';
    if (emptyElements[tab]) emptyElements[tab].hidden = true;
    if (errorElements[tab]) {
      errorElements[tab].hidden = false;
      if (errorTextElements[tab]) errorTextElements[tab].textContent = message || 'Failed to load coupons.';
    }
  }

  function renderList(tab, coupons) {
    hideLoading(tab);
    if (errorElements[tab]) errorElements[tab].hidden = true;

    var list = listElements[tab];
    if (!list) return;

    list.innerHTML = '';
    if (!coupons || !coupons.length) {
      if (emptyElements[tab]) emptyElements[tab].hidden = false;
      return;
    }

    coupons.forEach(function (coupon) {
      list.appendChild(renderCouponCard(coupon, tab));
    });
  }

  // Data loading functions
  function fetchAvailable() {
    showLoading('available');
    var url = COUPON_API_BASE + '/available?email=' + encodeURIComponent(currentUserEmail);
    return apiRequest(url).then(function (data) {
      renderList('available', Array.isArray(data) ? data : []);
    }).catch(function (error) {
      showError('available', error.message);
    });
  }

  function fetchUsed() {
    showLoading('used');
    var url = COUPON_API_BASE + '/used?email=' + encodeURIComponent(currentUserEmail) +
      '&page=' + usedState.page + '&pageSize=' + USED_PAGE_SIZE;
    return apiRequest(url).then(function (data) {
      var records = [];
      var total = 0;
      var pages = 1;
      if (data && typeof data === 'object') {
        if (Array.isArray(data.records)) {
          records = data.records;
          total = Number(data.total) || 0;
          pages = Number(data.pages) || 1;
        } else if (Array.isArray(data.list)) {
          records = data.list;
          total = Number(data.total) || 0;
        } else if (Array.isArray(data.data)) {
          records = data.data;
        }
      } else if (Array.isArray(data)) {
        records = data;
        total = records.length;
      }
      usedState.total = total || records.length;
      usedState.pages = pages || Math.max(1, Math.ceil(usedState.total / USED_PAGE_SIZE));
      renderList('used', records);
      updatePagination();
    }).catch(function (error) {
      showError('used', error.message);
    });
  }

  function fetchExpired() {
    showLoading('expired');
    var url = COUPON_API_BASE + '/available?email=' + encodeURIComponent(currentUserEmail) +
      '&couponType=ALL&includeExpired=true';
    return apiRequest(url).then(function (data) {
      // Backend may return expired coupons in available with a filter, or we need a dedicated endpoint.
      // If backend doesn't support includeExpired, try to filter client-side from all user coupons.
      var coupons = Array.isArray(data) ? data : [];
      var now = new Date();
      var expired = coupons.filter(function (coupon) {
        if (coupon.status === 'EXPIRED') return true;
        var until = coupon.validUntil || coupon.validUntilDate || '';
        if (until) {
          var date = new Date(until);
          if (!isNaN(date.getTime()) && date < now) return true;
        }
        return false;
      });
      renderList('expired', expired);
    }).catch(function (error) {
      // Fallback: try to load all coupons and filter client-side
      var url2 = COUPON_API_BASE + '/available?email=' + encodeURIComponent(currentUserEmail);
      return apiRequest(url2).then(function (data) {
        var coupons = Array.isArray(data) ? data : [];
        var now = new Date();
        var expired = coupons.filter(function (coupon) {
          if (coupon.status === 'EXPIRED') return true;
          var until = coupon.validUntil || coupon.validUntilDate || '';
          if (until) {
            var date = new Date(until);
            if (!isNaN(date.getTime()) && date < now) return true;
          }
          return false;
        });
        renderList('expired', expired);
      }).catch(function (error2) {
        showError('expired', error2.message);
      });
    });
  }

  function updatePagination() {
    paginationEl.hidden = usedState.pages <= 1;
    if (paginationPrev) paginationPrev.disabled = usedState.page <= 1;
    if (paginationNext) paginationNext.disabled = usedState.page >= usedState.pages;
    if (paginationInfo) {
      paginationInfo.textContent = 'Page ' + usedState.page + ' of ' + usedState.pages +
        ' (' + usedState.total + ' coupons)';
    }
  }

  // Tab switching
  function switchTab(tab) {
    tabs.forEach(function (tabButton) {
      var isActive = tabButton.getAttribute('data-coupon-tab') === tab;
      tabButton.classList.toggle('my-coupons__tab--active', isActive);
      tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    Object.keys(panels).forEach(function (key) {
      panels[key].hidden = key !== tab;
      panels[key].classList.toggle('my-coupons__panel--active', key === tab);
    });

    try {
      window.localStorage.setItem(ACTIVE_TAB_KEY, tab);
    } catch (storageError) {
      /* Storage optional. */
    }

    if (tab === 'available' && !listElements.available.innerHTML && emptyElements.available.hidden) {
      fetchAvailable();
    } else if (tab === 'used' && !listElements.used.innerHTML && emptyElements.used.hidden) {
      fetchUsed();
    } else if (tab === 'expired' && !listElements.expired.innerHTML && emptyElements.expired.hidden) {
      fetchExpired();
    }
  }

  function startApp() {
    if (!currentUserEmail) {
      showError('available', 'Email address not found. Please log in again.');
      showError('used', 'Email address not found. Please log in again.');
      showError('expired', 'Email address not found. Please log in again.');
      return;
    }

    tabs.forEach(function (tabButton) {
      tabButton.addEventListener('click', function () {
        switchTab(tabButton.getAttribute('data-coupon-tab'));
      });
    });

    if (paginationPrev) {
      paginationPrev.addEventListener('click', function () {
        if (usedState.page <= 1) return;
        usedState.page -= 1;
        fetchUsed();
      });
    }

    if (paginationNext) {
      paginationNext.addEventListener('click', function () {
        if (usedState.page >= usedState.pages) return;
        usedState.page += 1;
        fetchUsed();
      });
    }

    // Restore active tab
    var activeTab = 'available';
    try {
      var storedTab = window.localStorage.getItem(ACTIVE_TAB_KEY);
      if (storedTab && ['available', 'used', 'expired'].indexOf(storedTab) !== -1) {
        activeTab = storedTab;
      }
    } catch (storageError) {
      activeTab = 'available';
    }
    switchTab(activeTab);
  }

  // Initialize the page
  initializePage();
})();
